import { addLink } from '@api/services/project-link.service';
import { useMutation } from '@tanstack/react-query';
import * as Yup from 'yup';

const useLinkAddForm = (clientId: string, projectId: string) => {
    const addLinkMutation = useMutation((payload: any) => addLink(clientId, projectId, payload));
    const schema = Yup.object({
        name: Yup.string().trim().required('This field is required'),
        url: Yup.string().trim().required('This field is required'),
    });

    const initialValues: any = {
        name: '',
        url: '',
    };

    const submit = async (values: any) => {
        const data = await addLinkMutation.mutateAsync(values);

        return data;
    };

    return {
        isSubmitting: addLinkMutation.isLoading,
        initialValues,
        schema,
        submit,
    };
};

export default useLinkAddForm;
